import React, { useState, useEffect } from 'react';
import { getPriorityColor as getCalendarPriorityColor } from '../../services/calendar';

const CircularProgressComponent = ({ items }) => {
  const { width, height, priority } = items;
  const taskPriorityColors = ['#CDDC39', '#8BC34A', '#2196F3', '#FF9800', '#F44336'];

  // Öncelik rengi: Takvim (0-3) için servisle hizalı, görev (1-5) için yerel dizi
  const resolvePriorityColor = (p) => {
    const n = parseInt(p);
    if (Number.isFinite(n)) {
      if (n >= 0 && n <= 3) {
        return getCalendarPriorityColor(n);
      }
      if (n >= 1 && n <= 5) {
        return taskPriorityColors[n - 1];
      }
    }
    return '#2196F3';
  };
  const chosenColor = resolvePriorityColor(priority);

  const [progress, setProgress] = useState(0);

  const progressStyle = {
    width: width,
    height: height,
  };

  const indicatorStyle = {
    stroke: chosenColor,
    transition: 'stroke-dashoffset 1s ease-in-out',
    strokeDasharray: 125.66,
    strokeDashoffset: 125.66 - (progress / 100) * 125.66,
    strokeWidth: 8,
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + 10));
    }, 50); 

    setTimeout(() => {
      clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, []); 

  return (
    <svg style={progressStyle} viewBox="0 0 50 50">
      <circle className="stroke-current" style={indicatorStyle} cx="25" cy="25" r="20" fill="none" />
    </svg>
  );
};

export default CircularProgressComponent;
